import { c as _c } from "react/compiler-runtime";
import WorldMap from "@/components/ui/world-map";
export default function SiteWorldMap() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <WorldMap dots={[{
      start: {
        lat: 27.4168,
        lng: -4.7038
      },
      end: {
        lat: 27.6762,
        lng: -120.6503
      }
    }, {
      start: {
        lat: 27.4168,
        lng: -4.7038
      },
      end: {
        lat: -40.6762,
        lng: 140.6503
      }
    }, {
      start: {
        lat: 27.6762,
        lng: -120.6503
      },
      end: {
        lat: 6.6762,
        lng: -80.6503
      }
    }, {
      start: {
        lat: 6.6762,
        lng: -80.6503
      },
      end: {
        lat: -60.6762,
        lng: -70.6503
      }
    }, {
      start: {
        lat: -60.6762,
        lng: -70.6503
      },
      end: {
        lat: 27.4168,
        lng: -4.7038
      }
    }, {
      start: {
        lat: -40.6762,
        lng: 140.6503
      },
      end: {
        lat: 47.5074,
        lng: -3.1278
      }
    }]} lineColor="#ff4300" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}